export default {
  name: "WallSVG",
  props: {
    fill: {
      type: String,
      default: "#FFA621"
    }
  }
};